import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { externalLink } from '../../../../configs/externalLink'
import { Element } from '../../html/element'
import { Separator } from '../../separator'
import { HeaderForPreview } from './HeaderForPreview'
import { factSheetTypes } from './constants'
import { getPercentDiscount } from './helper'
import { selectData } from './store/slice'
import { getSampleReport } from './store/thunk'
import useGetOrganizationId from './useGetOrganizationId'

export const Header = ({ type, isBlockCompanyType }) => {
  const dispatch = useDispatch()

  const organizationId = useGetOrganizationId()

  const data = useSelector(selectData)
  const locale = useSelector((state) => state.i18n.locale)

  const downloadSampleReport = () => {
    dispatch(
      getSampleReport({
        FiinGateReportTypeId: data.fiinGateReportTypeId,
        OrganizationId: organizationId,
      }),
    )
  }

  const onClick = () => {
    window.open(externalLink.FACT_SHEET_SERVICE_DETAILS[locale], '__blank')
  }

  if (type === factSheetTypes.PREVIEW) {
    return (
      <HeaderForPreview
        downloadSampleReport={downloadSampleReport}
        isBlockCompanyType={isBlockCompanyType}
      />
    )
  }

  return (
    <Element style={{ marginBottom: 12 }}>
      <div className="dFlex justifyContentBetween alignItemsCenter gap1">
        <div>
          {type === factSheetTypes.POPUP_LITE ? (
            <div className="flexColumn">
              <Translate
                value="common.order.factSheet.PREVIEW_FACT_SHEET_DESC"
                dangerousHTML
              />
              <Translate
                value="common.order.factSheet.PREVIEW_FACT_SHEET_DESC_2"
                percent={getPercentDiscount(data, locale)}
                dangerousHTML
              />
            </div>
          ) : (
            <div>
              <Translate
                value="common.order.factSheet.POPUP_FACT_SHEET_DESC"
                dangerousHTML
              />
            </div>
          )}

          <Element className="mb1">
            <Element
              elementName="span"
              style={{ color: '#2C73E8', cursor: 'pointer' }}
              onClick={onClick}
            >
              <Translate value="common.order.factSheet.SERVICE_DETAIL" />
            </Element>
          </Element>
        </div>
        <Element
          elementName="span"
          className="cursorPointer whiteSpaceNowrap"
          style={{ color: '#2C73E8' }}
          onClick={downloadSampleReport}
        >
          <Translate value="common.order.factSheet.SAMPLE_REPORT" />
        </Element>
      </div>
      <Separator height={1} width="100%" backgroundColor="#D5D5D5" />
    </Element>
  )
}
